import { useState } from 'react';
import { useReducer } from 'spacetimedb/react';
import { reducers } from '../module_bindings';
import { DB_NAME, HOST } from './config';
import { setActive } from './identityStore';
import {
  navigate,
  notifyIdentityStoreUpdate,
  setActiveTokenHash,
  setSessionState,
  useCurrentUser,
} from './hooks';

const buttonStyle: React.CSSProperties = {
  background: '#2a3445',
  color: '#e7d9b6',
  border: 'none',
  padding: '6px 10px',
  borderRadius: 4,
  cursor: 'pointer',
  fontSize: 12,
  fontFamily: 'system-ui, sans-serif',
};

/**
 * In-game menu attached to the player-name chip in the corner.
 * Two actions: Reroll my name (server picks a new one), Log out.
 */
export function InGameMenu() {
  const [open, setOpen] = useState(false);
  const me = useCurrentUser();
  const reroll = useReducer(reducers.rerollName);

  const logOut = () => {
    // Clears active so the next visit goes through the picker. The
    // SessionGuard observes sessionState=IDENTITY_SELECT and unmounts
    // the provider, releasing the connection. We don't call disconnect
    // directly because the React provider ref-counts the managed
    // connection — unmounting is the right termination.
    setActive(HOST, DB_NAME, null);
    setActiveTokenHash('');
    setSessionState('IDENTITY_SELECT');
    notifyIdentityStoreUpdate();
    setOpen(false);
  };

  return (
    <div
      style={{
        position: 'absolute',
        top: 12,
        right: 12,
        zIndex: 30,
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          ...buttonStyle,
          background: 'rgba(0,0,0,0.55)',
          padding: '8px 12px',
        }}
      >
        {me?.name ?? '…'} {open ? '▴' : '▾'}
      </button>
      {open && (
        <div
          style={{
            marginTop: 6,
            background: 'rgba(14, 19, 32, 0.97)',
            color: '#e7d9b6',
            padding: 12,
            borderRadius: 6,
            minWidth: 160,
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
          }}
        >
          <button
            style={buttonStyle}
            onClick={() => {
              reroll();
              setOpen(false);
            }}
          >
            Reroll my name
          </button>
          {/* Dev convenience — remove once /tools has a stable entry point */}
          <button
            style={buttonStyle}
            onClick={() => {
              navigate('/tools');
              setOpen(false);
            }}
          >
            Tools →
          </button>
          <button style={buttonStyle} onClick={logOut}>
            Log out
          </button>
        </div>
      )}
    </div>
  );
}
